import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

import * as formData from '../../../queries/form-data';
import * as rewards from '../../../queries/rewards';

/**
 * The persister is used to persist query data in the browser's local storage. This should only be
 * used for intensive queries that are not frequently updated and do not require immediate updates. Think things
 * like the Country list for form data, which rarely changes, or the rewards filter list.
 *
 * When the app loads up it will prepopulate queries from local storage into the cache. If the user then
 * visits a page that uses the data it will first load what is in the cache and if the data is stale (
 * which will be very likely since stale time is only 10 minutes) React Query will refresh the data. The
 * user will very likely not experience any changes in this case.
 )
 * @returns
 */
export const createPersister = () => {
	return createSyncStoragePersister({
		key: 'BONUSLY_OFFLINE_STORAGE',
		throttleTime: 10 * 1000,
		storage: window.localStorage,
	});
};

export const shouldPersist = (query: any) => {
	// I added this in the function rather than outside of it. Some tests failed because stuff like
	// rewards.QueryKey was undefined. It seems like in tests the modules might not have been loaded in the correct order
	const allowedKeys: string[] = [formData.QueryKey.Countries, rewards.QueryKey.Filters, rewards.QueryKey.Rewards, rewards.QueryKey.ItemSubcategories];
	const [key] = query.queryKey;

	return query.state.status === 'success' && typeof key === 'string' && allowedKeys.includes(key);
};
